"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var angular = require("angular");
require('../craft-experiment/craft-experiment.component.css');
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var ISSUE_TYPE_COLOR = {
    Discovery: "#FFEAF4",
    Specify: "#FFFFB7",
    Navigate: "#C6DCFB",
    Manage: "#CFFFEE"
};
function discoveryGrid(ignorance, impact) {
    return ignorance >= 5 && impact >= 5
        ? "Discovery"
        : ignorance >= 5 && impact < 5
            ? "Specify"
            : ignorance < 5 && impact >= 5
                ? "Navigate"
                : "Manage";
}
var ExperimentViewComponent = /** @class */ (function () {
    function ExperimentViewComponent($rootScope, $scope, $timeout) {
        this.issueConfig = {};
        this.disableEdit = false;
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.$rootScope = $rootScope;
        ctrl.dashboardExpPriority = false;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DFV);
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.showGenerateBtn = false;
        ctrl.guideCommand = '';
        ctrl.stopLoadingSpinner = function () {
            $scope.$emit('workbench:loading', { 'load': false });
        };
        $scope.$on('command:EXPERIMENT_VIEW', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.guideCommand = '';
            ctrl.isDataLoaded = false;
            ctrl.initComponent(event, args);
            ctrl.getNColCanvasConfig();
            ctrl.clearDivs();
        });
        $timeout();
        $('select option')
            .filter(function () {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
            .remove();
    }
    ExperimentViewComponent.prototype.getNColCanvasConfig = function () {
        var ctrl = this;
        var config = ctrl.utilsService.getIssueConfigFromStorage(true);
        ctrl.issueConfig = config.issueConfig;
        ctrl.display = config.title;
    };
    ExperimentViewComponent.prototype.setGlobalDirty = function () {
        var ctrl = this;
        ctrl.$timeout(function () {
            ctrl.$rootScope.smartorgDirty = ctrl.isDirty;
        }, 0);
    };
    ExperimentViewComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem ? args.actionMenuItem : "Experiment View";
        // Handsonetable Setting
        ctrl.settings = {
            stretchH: "all",
            colWidths: ["35vw", "28vw", "30vw", "43vw", "28vw", "43vw", "28vw", "35vw", "42vw"],
            width: "80vw",
            licenseKey: "ee979-f3485-d8862-46b42-8ee23",
            cells: function (row, col) {
                var cellPrp = {};
                cellPrp.className = (col == 0) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                if (col === 7) {
                    cellPrp.renderer = ctrl.IssueTypeRenderer;
                }
                if (col === 5) {
                    cellPrp.renderer = ctrl.myRenderer;
                }
                if (col === 8) {
                    cellPrp.renderer = ctrl.myTooltipRenderer;
                }
                return cellPrp;
            },
            afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                if (coords.col == 0 && indexGotHere > -1) {
                    ctrl.selectIssue(indexGotHere);
                }
                ctrl.$scope.$apply();
            },
            afterGetColHeader: function (col, TH) {
                if (col === 2 || col === 4 || col == 8) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
            },
            afterColumnSort: function (currentSortCfg, destSortCfg) {
            },
            viewportColumnRenderingOffset: 70,
            columnSorting: true
        };
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.isQualitative = false;
        if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        }
        ctrl.fteGlobal = args.fte;
        ctrl.tornadoFactors = args.factors;
        ctrl.tornadoFactors.forEach(function (f) {
            f['Comment'] = decodeURIComponent(f['Comment']);
        });
        ctrl.tornadoFactors = ctrl.tornadoFactors.concat([
            { 'Factor': 'Chance of Failure - High (75% to 100%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Middle (Around 50%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Low (Less than 25%)', 'Comment': '' }
        ]);
        ctrl.origTornadoFactors = angular.copy(ctrl.tornadoFactors);
        ctrl.origStatus = ["Completed", "In Plan", "Backlog", "Unplanned"];
        ctrl.node = args.node;
        ctrl.issueData = [];
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
        ctrl.getIssueDetailsFromDb();
        ctrl.menu = [];
        ctrl.setGlobalDirty();
    };
    ExperimentViewComponent.prototype.showTable = function (issueData) {
        var ctrl = this;
        ctrl.clearDivs();
        ctrl.loadHotTableConfig();
        ctrl.isDataLoaded = true;
        var expViewTable = document.getElementById('exp-view-table');
        var hotExp = new Handsontable(expViewTable, __assign(__assign({}, ctrl.settings), { colHeaders: ctrl.colHeaders, columns: ctrl.columns, data: ctrl.issueData }));
    };
    ExperimentViewComponent.prototype.loadHotTableConfig = function () {
        var ctrl = this;
        ctrl.dropdownMenu = [
            "filter_by_value",
            "filter_action_bar",
            "filter_by_condition",
        ];
        ctrl.colHeaders = [
            "Experiment",
            "Status",
            "Total Cost",
            "Duration weeks",
            "Start Date",
            "% Completed",
            "Issue",
            "Issue Type",
            "Issue Surprise Index"
        ];
        ctrl.columns = [
            { data: "expName", className: "htLeft htMiddle cursor-pointer", readOnly: true },
            { data: "status", className: "htCenter htMiddle", readOnly: true },
            { data: "totalCost", className: "htCenter htMiddle", readOnly: true },
            { data: "duration", className: "htCenter htMiddle", readOnly: true },
            { data: "startDate", className: "htCenter htMiddle", readOnly: true },
            { data: "defined", className: "htCenter htMiddle", readOnly: true },
            { data: "name", className: "htCenter htMiddle", readOnly: true },
            { data: "issueType", className: "htCenter htMiddle", readOnly: true },
            {
                data: "combinedScore",
                className: "htCenter htMiddle",
                readOnly: true,
                columnSorting: {
                    sortEmptyCells: false,
                    indicator: true,
                    headerAction: true,
                    compareFunctionFactory: function (sortOrder, columnMeta) {
                        return function (value, nextValue) {
                            // if asc return 1 for greater else -1 for greater
                            var comp = value.score - nextValue.score;
                            return sortOrder == 'asc' ? comp * -1 : comp;
                        };
                    }
                }
            },
        ];
        ctrl.colWidths = ["35vw", "28vw", "30vw", "43vw", "28vw", "43vw", "28vw", "35vw", "42vw"];
    };
    ExperimentViewComponent.prototype.clearDivs = function () {
        try {
            document.getElementById('issues-handson').innerHTML = "";
        }
        catch (e) {
        }
    };
    ExperimentViewComponent.prototype.myTooltipRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        try {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.innerHTML = '';
            var divMain = document.createElement('DIV');
            if (value) {
                var imp = value.impact;
                var ig = value.ignorance;
                var sco = value.score;
                divMain.title = 'Impact:' + imp + ' Ignorace:' + ig;
                divMain.innerHTML = sco;
            }
            td.appendChild(divMain);
        }
        catch (error) {
        }
    };
    ExperimentViewComponent.prototype.IssueTypeRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = this;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        if (value) {
            try {
                td.style.backgroundColor = ISSUE_TYPE_COLOR[value.replace(/ /g, "")];
            }
            catch (e) {
            }
        }
    };
    ExperimentViewComponent.prototype.myRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        try {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.innerHTML = '';
            var divMain = document.createElement('DIV');
            divMain.className = 'process-back';
            var valuePara = document.createElement('p');
            valuePara.className = 'process-value';
            valuePara.innerHTML = value + " %";
            var div = document.createElement('DIV');
            div.className = 'process';
            div.style.width = value + '%';
            divMain.appendChild(valuePara);
            divMain.appendChild(div);
            td.appendChild(divMain);
        }
        catch (e) { }
    };
    ExperimentViewComponent.prototype.discoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "Discovery"
            : ignorance >= 5 && impact < 5
                ? "Specify"
                : ignorance < 5 && impact >= 5
                    ? "Navigate"
                    : "Manage";
    };
    ExperimentViewComponent.prototype.selectFactor = function () {
        var ctrl = this;
        ctrl.currExperiment.issueFactor = ctrl.selectedFactor;
        ctrl.checkSave();
    };
    ExperimentViewComponent.prototype.selectStatus = function () {
        var ctrl = this;
        ctrl.currExperiment.status = ctrl.selectedStatus;
        ctrl.checkSave();
    };
    ExperimentViewComponent.prototype.getDefined = function () {
        var ctrl = this;
        var total = 8;
        var done = 0;
        if (ctrl.currExperiment.expName)
            done++;
        if (ctrl.currExperiment.needToLearn)
            done++;
        if (ctrl.currExperiment.goingToLearn)
            done++;
        if (ctrl.currExperiment.toMeasure)
            done++;
        if (ctrl.currExperiment.successCriteria)
            done++;
        if (ctrl.currExperiment.cost)
            done++;
        if (ctrl.currExperiment.duration)
            done++;
        if (ctrl.currExperiment.resourceFte)
            done++;
        return Math.round((done * 100) / total);
    };
    ExperimentViewComponent.prototype.getIssueDetailsFromDb = function () {
        var _this = this;
        var ctrl = this;
        ctrl.smartorg.getInavIssueAndExperiment(ctrl.node['_id']).then(function (res) {
            if (res.status == 1) {
                ctrl.stopLoadingSpinner();
                ctrl.showAlert('danger', 'Error!', res.message);
            }
            else {
                ctrl.issueData = res.map(function (item) {
                    var formatted = _this.utilsService.formatIssueData(item, ctrl.isQualitative, ctrl.fteGlobal);
                    formatted.defined = _this.utilsService.getExperimentDefined(formatted);
                    return formatted;
                });
                ctrl.issueData = ctrl.issueData.filter(function (i) { return i.status !== "Unplanned"; });
                ctrl.issueData.sort(function (a, b) { return (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0); });
                ctrl.showGenerateBtn = true;
                ctrl.menu = [];
                ctrl.stopLoadingSpinner();
                ctrl.showTable(ctrl.issueData);
                ctrl.$scope.$apply();
            }
        })["catch"](function (err) {
            ctrl.stopLoadingSpinner();
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    ExperimentViewComponent.prototype.initSelectFactors = function () {
        var ctrl = this;
        if (ctrl.currExperiment.issueFactor) {
            if (ctrl.currExperiment.impactMappingList && ctrl.currExperiment.impactMappingList != "default") {
                var selectedFactorIndex = ctrl.currExperiment.impactMappingList.findIndex(function (f) { return (ctrl.currExperiment.issueFactor.key === f.key); });
                ctrl.selectedFactor = ctrl.currExperiment.impactMappingList[selectedFactorIndex];
            }
        }
        else {
            ctrl.selectedFactor = undefined;
        }
    };
    ExperimentViewComponent.prototype.initSelectStatus = function () {
        var ctrl = this;
        if (ctrl.currExperiment.status) {
            var selectedStatusIndex = ctrl.origStatus.findIndex(function (f) { return (ctrl.currExperiment.status === f); });
            ctrl.selectedStatus = ctrl.origStatus[selectedStatusIndex];
        }
        else {
            ctrl.selectedStatus = undefined;
        }
    };
    ExperimentViewComponent.prototype.clearSelection = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
    };
    ExperimentViewComponent.prototype.selectIssue = function (index) {
        var ctrl = this;
        ctrl.selectedIndex = index;
        ctrl.selectedIssue = ctrl.issueData[index];
        $("#experimentInput").focus();
        ctrl.currExperiment = ctrl.utilsService.getIssueDetails(ctrl.selectedIssue, ctrl.fteGlobal);
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.initSelectFactors();
        ctrl.initSelectStatus();
        ctrl.expSelected = true;
        ctrl.$scope.$apply();
    };
    ExperimentViewComponent.prototype.updateCurrExp = function () {
        var ctrl = this;
        ctrl.expSelected = true;
        ctrl.checkSave();
    };
    ExperimentViewComponent.prototype.updateIterPlanInIssueData = function () {
        var ctrl = this;
        var updatedIssueData = angular.copy(ctrl.issueData);
    };
    ExperimentViewComponent.prototype.resetBack = function () {
        var ctrl = this;
        ctrl.currExperiment = angular.copy(ctrl.origCurrExperiment);
        // ctrl.checkSave();
        ctrl.clearSelection();
    };
    ExperimentViewComponent.prototype.saveCurrentExp = function () {
        var ctrl = this;
        ctrl.updatedIssueData = ctrl.utilsService.updateIssueData(ctrl.issueData, ctrl.selectedIndex, ctrl.currExperiment, ctrl.fteGlobal);
        ctrl.issueData = angular.copy(ctrl.updatedIssueData);
        ctrl.saveExperimentData();
    };
    ExperimentViewComponent.prototype.saveExperimentData = function () {
        var ctrl = this;
        var issueToBeSaved = angular.copy(ctrl.issueData[ctrl.selectedIndex]);
        var experimentToBeSaved = angular.copy(issueToBeSaved['experimentData'][0]);
        if (experimentToBeSaved['_id'] == '') {
            delete experimentToBeSaved['_id'];
        }
        this.smartorg.saveInavExperimentData(issueToBeSaved['_id'], experimentToBeSaved).then(function (res) {
            if (res.status == 0) {
                ctrl.isDirty = false;
                ctrl.setGlobalDirty();
                ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
                ctrl.showAlert('success', 'Saved!', 'Details saved for experiment "' +
                    ctrl.issueData[ctrl.selectedIndex]['expName'] + '"');
                ctrl.clearSelection();
                ctrl.isDataLoaded = false;
                ctrl.getIssueDetailsFromDb();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    ExperimentViewComponent.prototype.onFteChange = function () {
        var ctrl = this;
        ctrl.utilsService.onFteChange(ctrl.currExperiment, ctrl.fteGlobal, function () { ctrl.checkSave(); });
    };
    ExperimentViewComponent.prototype.checkSave = function () {
        var ctrl = this;
        ctrl.isDirty = this.utilsService.checkSave(ctrl.currExperiment, ctrl.origCurrExperiment);
        ctrl.setGlobalDirty();
    };
    return ExperimentViewComponent;
}());
angular.module('smartorg.r6.acts.experimentView', []).component('experimentView', {
    template: require('./experiment-view.component.html'),
    controller: ExperimentViewComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.experimentView';
//# sourceMappingURL=experiment-view.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/experiment-view/experiment-view.component.js